// Configurações para agendamento de prova
export const LOCAIS_PROVA = [
  { value: "atelier", label: "🏢 No Ateliê", description: "Cliente vem até o ateliê" },
  { value: "cliente", label: "🏠 Casa do Cliente", description: "Visita na residência" },
  { value: "video", label: "📱 Vídeo Chamada", description: "Via videochamada" },
];

export const RESULTADOS_PROVA = [
  { value: "aprovada", label: "✅ Aprovada", color: "green" },
  { value: "ajustes_necessarios", label: "⚠️ Ajustes Necessários", color: "yellow" },
  { value: "nao_realizada", label: "❌ Não Realizada", color: "red" },
];

export interface ProvaAgendada {
  // Identificação
  id: string;

  // Agendamento (planejado)
  data_prova: string; // ISO date YYYY-MM-DD
  hora_prova: string; // HH:mm
  local_prova: "atelier" | "cliente" | "video";
  observacoes_agendamento?: string;

  // Realização (o que realmente aconteceu)
  realizada?: boolean; // true se foi feita
  data_realizacao?: string; // ISO date - quando realmente aconteceu
  hora_realizacao?: string; // HH:mm - hora que realmente aconteceu
  resultado_prova?: "aprovada" | "ajustes_necessarios" | "nao_realizada";
  observacoes_resultado?: string; // cliente gostou? precisa ajustes?

  // Status
  confirmada: boolean; // cliente confirmou?

  // Timestamps
  data_agendamento: string; // ISO timestamp
  data_atualizacao?: string; // ISO timestamp - última vez que foi editada
}

export interface ProvaHistorico {
  data_agendamento: string;
  cliente_id: string;
  cliente_nome: string;
  pedido_numero: string;
  data_prova: string;
  hora_prova: string;
  local_prova: string;
  observacoes_agendamento?: string;
  realizada?: boolean;
  data_realizacao?: string;
  hora_realizacao?: string;
  resultado_prova?: string;
  observacoes_resultado?: string;
  confirmada: boolean;
}
